import { render, staticRenderFns } from "./MagicValidator.vue?vue&type=template&id=01462732&scoped=true"
import script from "./MagicValidator.vue?vue&type=script&lang=ts"
export * from "./MagicValidator.vue?vue&type=script&lang=ts"
import style0 from "./MagicValidator.vue?vue&type=style&index=0&id=01462732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01462732",
  null
  
)

export default component.exports